import angular from 'angular';

/**
 * Creates a new DownloadService.
 * Service which provide API to download file
 * @class DownloadService.
 */
export function DownloadService() {
    /**
     * @param {blob} data - Blob data of the file
     * @param {string} options - File options
     * @param {string} options.fileType - File type
     * @param {string} options.fileName - File name
     */
    const downloadFile = (data, options) => {
        // eslint-disable-next-line no-undef
        const blob = new Blob([data], { type: options.fileType || 'plain/text' });
        const url = window.URL || window.webkitURL;
        const fileURL = url.createObjectURL(blob);
        const fileName = options.fileName || 'Document';

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    };

    return {
        downloadFile,
    };
}

angular.module('TALENYA-FE').factory('DownloadService', DownloadService);
